import { render, staticRenderFns } from "./wizard-template-complete.vue?vue&type=template&id=24343b05"
import script from "./wizard-template-complete.vue?vue&type=script&lang=js"
export * from "./wizard-template-complete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports